import { useTranslation } from "react-i18next";
import { M_InputTextField } from "../../../../M_Components";

export const AttachmentForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const handleNumberValueChange = (property, value) => {
        const regex = /^[1-9]\d*$/;
        if (regex.test(value)) {
            if (value === "") {
                propertyChangeCallback(property, null);
                return;
            }
            propertyChangeCallback(property, value);
        }
    }

    return (
        <>
            <M_InputTextField
                label={t("NgeMaxFileSizeInBytes")}
                value={field.maxFileSizeInBytes ?? ""}
                onChange={(e) => handleNumberValueChange("maxFileSizeInBytes", e.target.value)}
                disabled={!canEdit}
                type="number"
            />
        </>
    )
}
